import React, { useState, useEffect, useRef, useMemo } from "react";
import "./Hero.css";
import {
  FaLinkedin,
  FaGithub,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaArrowLeft,
} from "react-icons/fa";

const Hero = () => {
  const roles = useMemo(
    () => [
      "Web_Developer_",
      "App_Developer_",
      "AI_Product_Developer_",
      "Deployment_Operator_ ",
    ],
    []
  );
  const longestRole = useMemo(
    () => roles.reduce((a, b) => (a.length > b.length ? a : b), roles[0]),
    [roles]
  );

  const [roleIndex, setRoleIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);
  const prefersReducedMotion = useRef(false);

  useEffect(() => {
    if (typeof window !== "undefined" && window.matchMedia) {
      const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
      prefersReducedMotion.current = mql.matches;
    }
  }, []);

  useEffect(() => {
    if (prefersReducedMotion.current) return; // No animation if user prefers reduced motion

    const current = roles[roleIndex];
    const typingSpeed = deleting ? 50 : 120;
    const holdTime = 1500;

    if (!deleting && subIndex === current.length) {
      const timeout = setTimeout(() => setDeleting(true), holdTime);
      return () => clearTimeout(timeout);
    }

    if (deleting && subIndex === 0) {
      setDeleting(false);
      setRoleIndex((prev) => (prev + 1) % roles.length);
      return;
    }

    const timeout = setTimeout(() => {
      setSubIndex((prev) => prev + (deleting ? -1 : 1));
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [subIndex, deleting, roleIndex, roles]);

  const displayed = prefersReducedMotion.current
    ? roles[0]
    : roles[roleIndex].substring(0, subIndex);

  return (
    <div className="home">
      <div className="home-img">
        <img
          src="harsha.webp"
          alt="Harsha"
          // className={isBlue ? "blue-filter" : ""}
        />
      </div>
      <div className="home-content">
        <h1>
          Hi, I’m <span>Harsha</span>
        </h1>
        <h3 className="typing-text">
          I'm a<span className="cursor" aria-hidden="true"></span>
          <span
            className="word-wrap"
            aria-live="polite"
            aria-atomic="true"
            style={{ width: `${longestRole.length}ch` }}
          >
            {displayed}
          </span>
        </h3>
        <p>
          Hey there! Harsha, a passionate software developer with a knack for
          turning complex problems into elegant solutions. I’m always up for a
          challenge and love collaborating on exciting projects. Let’s connect
          and see where our shared interests can take us!
        </p>
        <div className="social-icons">
          <a
            href="https://www.linkedin.com/in/sai-harsha-vardhan-pittada-8a9a74252/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://github.com/leocodeio"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithub />
          </a>
          <a
            href="https://x.com/leocodeio"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitter />
          </a>
          <a
            href="https://www.instagram.com/leocodeio"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.youtube.com/@leocodeio"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube />
          </a>
        </div>
        <div style={{ display: "flex" }}>
          <a
            // href="https://drive.google.com/file/d/1xS3EYL80qoEzinq8HGOWW-eCsNruX64x/view?usp=sharing"
            href="https://x.com/messages/compose?recipient_id=1790271140708941824"
            className="btn"
          >
            Hire me
          </a>
          <div
            className="resume-link"
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "10px",
              fontSize: "20px",
              fontWeight: "bold",
              justifyContent: "center",
            }}
          >
            <FaArrowLeft style={{ marginRight: "5px" }} />
            <span>Connect</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
